import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deleteModalRecoil,
} from '@/atom/ModalAtom';
import {
  dashboardFacilityRecoil,
  dashboardRegionRecoil,
} from '@/atom/DashboardAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { DashBoardApi } from '@/sdk/DashBoardApi';
import AllDevice from './dashboard/AllDevice';
import ModelChart from './dashboard/ModelChart';
import DailyEventNum from './dashboard/DailyEventNum';
import TabFacility from './dashboard/TabFacility';
import TabArea from './dashboard/TabArea';

const Dashboard = () => {
  const dashBoardApi = new DashBoardApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const [dashboardFacilityState, setDashboardFacilityState] = useRecoilState(
    dashboardFacilityRecoil,
  );
  const [dashboardRegionState, setDashboardRegionState] = useRecoilState(
    dashboardRegionRecoil,
  );

  const [tab1ActiveIndex, setTab1ActiveIndex] = useState<number>(0);

  const fetchDashboardFacility = async () => {
    try {
      const { data } =
        await dashBoardApi.dashboardControllerGetDashBoardFacility({
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        });
      setDashboardFacilityState(data);
    } catch (err: any) {}
  };

  const fetchDashboardRegion = async () => {
    try {
      const { data } = await dashBoardApi.dashboardControllerGetDashBoardRegion(
        {
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setDashboardRegionState(data);
    } catch (err: any) {}
  };

  useEffect(() => {
    fetchDashboardFacility();
    fetchDashboardRegion();
  }, []);

  return (
    <>
      <Wrap className="flex">
        <LeftBox className="flex fdc">
          <AllDevice />
          <ModelChart />
          <DailyEventNum />
        </LeftBox>
        <RightBox className="flex fdc">
          <CntBox4 className="flex fdc">
            <CS.TabMenuType1>
              <button
                type="button"
                className={tab1ActiveIndex === 0 ? 'active' : ''}
                onClick={() => setTab1ActiveIndex(0)}
              >
                시설물
              </button>
              <button
                type="button"
                className={tab1ActiveIndex === 1 ? 'active' : ''}
                onClick={() => setTab1ActiveIndex(1)}
              >
                지역
              </button>
            </CS.TabMenuType1>
            {tab1ActiveIndex === 0 && <TabFacility />}
            {tab1ActiveIndex === 1 && <TabArea />}
          </CntBox4>
        </RightBox>
      </Wrap>
    </>
  );
};

export default Dashboard;

export const Wrap = styled.div`
  width: 100%;
  gap: 20px;
  max-height: calc(100vh - 72px);
  @media (max-width: 1420px) {
    gap: 12px;
  }
`;

export const LeftBox = styled.div`
  width: 520px;
  gap: 20px;
  @media (max-width: 1420px) {
    width: 40%;
    gap: 12px;
    > ${CS.CntBoxType1} {
      gap: 8px;
    }
  }
`;

export const RightBox = styled.div`
  width: calc(100% - 540px);
  > ${CS.CntBoxType1} {
    flex: 1 0 0%;
  }
  @media (max-width: 1420px) {
    width: 60%;
  }
`;

export const CntBox4 = styled(CS.CntBoxType1)`
  position: relative;
  > p {
    font-size: 16px;
    color: #222;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-width: 1420px) {
    > p {
      font-size: 14px;
    }
  }
`;
